module.exports = __webpack_public_path__ + "img/Ins_Volt_L1.3952d7ad.jpeg";